import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getStepService } from 'services/ekyc';
import { StepDataType, FormEkycData } from 'services/ekyc/types';

interface EkycState {
  uuid: string;
  step?: StepDataType;
  loading?: boolean;
  isVcbsDigiBankFlow?: boolean;
  formEkycData?: FormEkycData;
}

const initialState: EkycState = {
  uuid: '',
  step: undefined,
  loading: false,
  isVcbsDigiBankFlow: false,
  formEkycData: undefined,
};

export const getEkycDataAction = createAsyncThunk<
StepDataType,
string,
{ rejectValue: ErrorResponse }
>(
  'ekycReducer/getEkyc',
  async (uuId, { rejectWithValue }) => {
    try {
      return await getStepService(uuId);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  },
);

export const ekycSlice = createSlice({
  name: 'ekycReducer',
  initialState,
  reducers: {
    setFormEkycData: ($state, action: PayloadAction<FormEkycData | undefined>) => {
      $state.formEkycData = action.payload;
    },
    setUuid: ($state, action: PayloadAction<string>) => {
      $state.uuid = action.payload;
    },
    clearUuid: ($state) => {
      $state.uuid = initialState.uuid;
    },
    setVcbsDigiBankFlow: ($state, action: PayloadAction<boolean>) => {
      $state.isVcbsDigiBankFlow = action.payload;
    },
    clearState: ($state) => {
      $state.uuid = initialState.uuid;
      $state.step = initialState.step;
      $state.formEkycData = initialState.formEkycData;
    },
  },
  extraReducers(builder) {
    builder.addCase(getEkycDataAction.pending, ($state) => {
      $state.loading = true;
    });
    builder.addCase(getEkycDataAction.fulfilled, ($state, action) => {
      $state.loading = false;
      $state.step = action.payload;
    });
  },
});

export const {
  setUuid,
  clearUuid,
  clearState,
  setVcbsDigiBankFlow,
  setFormEkycData,
} = ekycSlice.actions;

export default ekycSlice.reducer;
